module.exports = __webpack_public_path__ + "img/f2.103441ba.jpeg";